import {
  Button,
  Stack,
  Box,
  Container,
  Heading,
  HStack,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import { z } from 'zod'
import { Form } from '@components/Forms/Form'
import { TextInput } from '@components/Forms/Inputs/TextInput'
import { Logo } from '@components/Elements/Logo'
import { FormWrapper } from '@components/Forms/Wrappers/FormWrapper'

const formSchema = z.object({
  email: z.string().email(),
})

interface Props {
  onSubmit: (values: z.infer<typeof formSchema>) => Promise<boolean>
}

export const ForgotPasswordLayout: FC<Props> = ({ onSubmit }) => {
  const [isSubmiting, setIsSubmitting] = useState<boolean>(false)
  const [isEmailSent, setIsEmailSent] = useState<boolean>(false)
  const [emailAddress, setEmailAddress] = useState<string>('')
  const headingBreakPoints = useBreakpointValue({ base: 'xs', md: 'sm' })

  const handleSubmit = async (values) => {
    setIsSubmitting(true)

    const success = await onSubmit(values)
    if (success) {
      setEmailAddress(values.email)
      setIsEmailSent(true)
    }

    setIsSubmitting(false)
  }

  if (isEmailSent) {
    return (
      <Container maxW="md" py={{ base: '12', md: '24' }}>
        <Stack spacing="8">
          <Stack spacing="6">
            <Box px="120" py="50" marginTop="30px">
              <Logo />
            </Box>
            <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
              <Heading size={headingBreakPoints}>
                Reset Password Email sent to {emailAddress}
              </Heading>
              <HStack spacing="1" justify="center">
                <Text color="muted">
                  Didn't recieve your email? We'll send you another one, Click{' '}
                  <Button
                    color={'blue.200'}
                    onClick={() => setIsEmailSent(false)}
                    variant={'link'}
                  >
                    here
                  </Button>
                </Text>
              </HStack>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    )
  }

  return (
    <Container maxW="md" py={{ base: '12', md: '24' }}>
      <Stack spacing="8">
        <Stack spacing="6">
          <Box px="120" py="50" marginTop="30px">
            <Logo />
          </Box>
          <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
            <Heading size={headingBreakPoints}>Forgot your password?</Heading>
            <HStack spacing="1" justify="center">
              <Text color="muted">
                Enter your email address and we'll send you a reset password
                email
              </Text>
            </HStack>
          </Stack>
        </Stack>
        <FormWrapper formSchema={formSchema}>
          <Form onSubmit={handleSubmit}>
            <Stack spacing="6">
              <TextInput name={'email'} label={'Email'} placeholder={'Email'} />
              <Button
                type={'submit'}
                colorScheme={'blue'}
                variant={'solid'}
                isLoading={isSubmiting}
              >
                Send
              </Button>
            </Stack>
          </Form>
        </FormWrapper>
      </Stack>
    </Container>
  )
}
